<template>
  <div class="inquiryList contentsWidth mx-auto mt-4">
    <div class="contentsWidth mx-auto mt-4">

      <div class="subject">
        <p class="title mb-0">問合せ履歴 - 一覧</p>
        <hr class="title">
      </div>

      <div id="searchWrap" class="mt-4">
        <div class="bold">絞り込み条件</div>
        <div class="search_area flex flex-wrap">
          <div class="searchMiddle inlineBlock searchSpace">
            <div>氏名</div>
            <div>
              <b-form-input v-model="fName" placeholder="入力してください。"/>
            </div>
          </div>
          <div class="searchShort inlineBlock searchSpace">
            <div>区分</div>
            <div>
              <b-form-select v-model="fSenderCategory" :options="categoryOptions">
                <template v-slot:first>
                  <option :value="null">-- すべて --</option>
                </template>
              </b-form-select>
            </div>
          </div>
          <div class="searchShort inlineBlock searchSpace">
            <div>ステータス</div>
            <div>
              <b-form-select v-model="fStatus" :options="statusOptions">
                <template v-slot:first>
                  <option :value="null">-- すべて --</option>
                </template>
              </b-form-select>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-between my-2 mt-3">
        <b-pagination
          class="mb-1"
          :value="currentPage"
          @input="setCurrentPage($event)"
          :total-rows="totalRows"
          :per-page="perPage"/>
        <div>
          <div class="inlineBlock mr-2">
            {{ nowPageCount }}件 / 全{{ totalRows }}件
          </div>
          <div class="inlineBlock mr-2">
            <span class="mr-2">表示件数</span>
            <b-form-select
              class="per-page-select"
              :value="perPage"
              @change="setPerPage"
              :options="pageOptions"/>
          </div>
        </div>
      </div>
      <b-table
        show-empty
        :fields="heads"
        :items="filteredList"
        id="inquiryListCms"
        thead-tr-class="head"
        tbody-tr-class="line"
        class="mt-3"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @row-clicked="goDetail">
        <template v-slot:cell(name)="row">
          <div>{{ row.item.name }}</div>
          <!-- No.9 Phase C：氏名欄は「投稿した人」なので、代行者の問合せでは誰の件か分からない。
               代行者の投稿を含むスレッドだけ「◯◯ の代行」を2行目に併記する。
               日本語は指定が無いと1文字単位で折り返されるため nowrap を必ず付ける（zz04）。 -->
          <div v-if="row.item.hasAgentMessage" class="principalName">
            {{ row.item.principalName || '(不明)' }} の代行
          </div>
        </template>
        <template v-slot:cell(senderCategory)="data">
          <span
            v-if="data.item.senderCategory"
            :class="['categoryBadge', categoryClass(data.item.senderCategory)]">{{ categoryTexts[data.item.senderCategory] }}</span>
          <span v-else>—</span>
        </template>
        <template v-slot:cell(status)="data">
          {{ statusTexts[data.item.status] }}
        </template>
        <template v-slot:cell(detail)="row">
          <b-link @click.stop="goDetail(row.item)">詳細</b-link>
        </template>
        <template v-slot:empty>
          <p class="none-data">問合せはありません。</p>
        </template>
      </b-table>

    </div>
  </div>
</template>

<script>
import api from '@/modules/api';
import moment from 'moment';
import INQUIRY from '@/constants/inquiryStatus';

export default {
  name: 'cmsInquiriesList',
  data() {
    return {
      pageOptions: [10, 20, 50],
      statusTexts: INQUIRY.CMS_INQUIRY_STATUS_TEXTS,
      statusOptions: Object.keys(INQUIRY.CMS_INQUIRY_STATUS_TEXTS).map(value => ({
        value: Number(value),
        text: INQUIRY.CMS_INQUIRY_STATUS_TEXTS[value],
      })),
      // 区分（最新の申請者投稿の区分）表示ラベル・絞り込み選択肢
      categoryTexts: INQUIRY.INQUIRY_SENDER_CATEGORY_TEXTS,
      categoryOptions: Object.keys(INQUIRY.INQUIRY_SENDER_CATEGORY_TEXTS).map(value => ({
        value: Number(value),
        text: INQUIRY.INQUIRY_SENDER_CATEGORY_TEXTS[value],
      })),
      heads: [
        { key: 'name', label: '氏名', sortable: true, class: 'name' },
        { key: 'senderCategory', label: '区分', sortable: true, class: 'category' },
        { key: 'title', label: 'タイトル', sortable: true, class: 'title-col' },
        { key: 'updated_at', label: '最終更新日時', sortable: true, class: 'updated' },
        { key: 'status', label: 'ステータス', sortable: true, class: 'status' },
        { key: 'detail', label: '', sortable: false, class: 'detail' },
      ],
      list: [],
    };
  },
  async created() {
    await this.fetchList();
  },
  computed: {
    // --- 検索・ページング・ソートは cmsInquiriesSearch ストアで保持（詳細から戻っても消えない） ---
    fName: {
      get() { return this.$store.state.cmsInquiriesSearch.filter.name; },
      set(v) { this.$store.commit('cmsInquiriesSearch/setFilter', { key: 'name', value: v }); },
    },
    fStatus: {
      get() { return this.$store.state.cmsInquiriesSearch.filter.status; },
      set(v) { this.$store.commit('cmsInquiriesSearch/setFilter', { key: 'status', value: v }); },
    },
    fSenderCategory: {
      get() { return this.$store.state.cmsInquiriesSearch.filter.senderCategory; },
      set(v) {
        this.$store.commit('cmsInquiriesSearch/setFilter', { key: 'senderCategory', value: v });
      },
    },
    sortBy: {
      get() { return this.$store.state.cmsInquiriesSearch.sortBy; },
      set(v) { this.$store.commit('cmsInquiriesSearch/setSortBy', v); },
    },
    sortDesc: {
      get() { return this.$store.state.cmsInquiriesSearch.sortDesc; },
      set(v) { this.$store.commit('cmsInquiriesSearch/setSortDesc', v); },
    },
    perPage() { return this.$store.state.cmsInquiriesSearch.perPage; },
    currentPage() { return this.$store.state.cmsInquiriesSearch.currentPage; },
    filteredList() {
      return this.list.filter((row) => {
        // No.9 Phase C：投稿者名だけでなく代行対象（採択者）名でもヒットさせる。
        // 採択者名で検索すれば本人の問合せと代行者の問合せが両方出る＝案件単位で追える。
        // hasAgentMessage を条件に含めるのは、画面に出していない情報で絞り込まないため。
        const okName = !this.fName
          || row.name.indexOf(this.fName) !== -1
          || (row.hasAgentMessage && row.principalName.indexOf(this.fName) !== -1);
        const okStatus = this.fStatus === null || row.status === this.fStatus;
        // 絞り込みは区分列の値（＝最新の申請者投稿の区分）と一致
        const okCategory = this.fSenderCategory === null
          || row.senderCategory === this.fSenderCategory;
        return okName && okStatus && okCategory;
      });
    },
    totalRows() {
      return this.filteredList.length;
    },
    nowPageCount() {
      if (this.totalRows === 0) {
        return 0;
      }
      let maxPage = Math.floor(this.totalRows / this.perPage);
      const mod = this.totalRows % this.perPage;
      let lastPageItemNum;
      if (mod !== 0) {
        maxPage += 1;
        lastPageItemNum = mod;
      } else {
        lastPageItemNum = this.perPage;
      }
      if (this.currentPage < maxPage) {
        return this.perPage;
      }
      return lastPageItemNum;
    },
  },
  methods: {
    async fetchList() {
      try {
        const res = await api.send('/api/cms/inquiries/list');
        const list = (res.data && res.data.list) || [];
        this.list = list.map(row => ({
          id: row.id,
          name: row.applicant_name,
          // No.9 Phase C：代行対象（スレッドの持ち主＝採択者）の氏名と、代行者投稿の有無
          principalName: row.principal_name || '',
          hasAgentMessage: Number(row.agent_message_count) > 0,
          senderCategory: row.sender_category,
          title: row.title,
          status: row.status,
          updated_at: this.formatDate(row.updated_at),
        }));
      } catch (e) {
        this.list = [];
      }
    },
    formatDate(dt) {
      return dt ? moment(dt).format('YYYY/MM/DD HH:mm') : '';
    },
    setCurrentPage(page) {
      this.$store.commit('cmsInquiriesSearch/setCurrentPage', page);
    },
    setPerPage(num) {
      this.$store.commit('cmsInquiriesSearch/setPerPage', num);
    },
    categoryClass(category) {
      // No.9 (B)：代行者の投稿を判別できるよう色を分ける（回答に何を書くかの判断に直結する）
      if (category === INQUIRY.INQUIRY_SENDER_CATEGORY.AGENT) {
        return 'cat-agent';
      }
      return category === INQUIRY.INQUIRY_SENDER_CATEGORY.ADOPTEE ? 'cat-adoptee' : 'cat-applicant';
    },
    goDetail(item) {
      this.$router.push({ name: 'cmsInquiriesDetail', query: { id: item.id } });
    },
  },
};
</script>

<style scoped>
  #searchWrap input, #searchWrap select {
    height: 50px;
  }
  .search_area {
    background: #DDD;
    padding: 10px;
    margin-bottom: 30px;
  }
  .searchMiddle {
    width: 205px;
  }
  .searchShort {
    width: 135px;
  }
  .searchSpace {
    margin-right: 15px;
    margin-bottom: 5px;
  }
  .none-data {
    margin-bottom: 1px;
    text-align: center;
  }
  .categoryBadge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 13px;
  }
  .categoryBadge.cat-applicant {
    background-color: #EAF1FB;
    color: #2F5597;
  }
  .categoryBadge.cat-agent {
  background: #E3F3E1;
  color: #2C6B2F;
  border: 1px solid #BCDCB8;
}
.cat-adoptee {
    background-color: #FBEBD9;
    color: #B9651B;
  }
</style>
<style>
  #inquiryListCms thead .head {
    background-color: #6E6E6E;
    color: #FFFFFF;
    font-weight: 600;
  }
  #inquiryListCms thead .head th {
    border: solid 1px #CCCCCC;
    word-break: keep-all;
  }
  #inquiryListCms tbody tr.line {
    border-bottom: solid 1px #CCCCCC;
    cursor: pointer;
  }
  #inquiryListCms tbody tr td {
    vertical-align: middle !important;
  }
  /* 幅の根拠：置ける幅 = 220 - セル余白14.4 = 205.6px。
     1行目 氏名（最長9文字相当≒144px）／2行目「◯◯ の代行」（≒128px）とも収まる */
  #inquiryListCms td.name { width: 220px; }
  #inquiryListCms .principalName {
    font-size: 85%;
    color: #666;
    white-space: nowrap;
  }
  #inquiryListCms td.category { width: 90px; text-align: center; }
  #inquiryListCms td.updated { width: 180px; }
  #inquiryListCms td.status { width: 120px; }
  #inquiryListCms td.detail { width: 80px; text-align: center; }
</style>
